import React from 'react';
import { connect } from 'react-redux';
import { goToSubstep } from 'registration/creative/ducks';
import { updateMobilePhone } from 'common/ducks/user';
import Substep2_4 from 'registration/creative/components/substep2_4';

const mapStateToProps = ({
  user,
  creativeRegistration: {
    idPhoto, selfie, workSamples, sampleGroups, idValidated, registrationSubmittedAt,
    registrationReopenedAt
  }
}) => {
  return {
    user,
    idPhoto,
    selfie,
    workSamples,
    sampleGroups,
    idValidated,
    registrationSubmittedAt,
    registrationReopenedAt
  };
}

export default connect(mapStateToProps, {
  goToSubstep,
  updateMobilePhone,
})(Substep2_4);



// WEBPACK FOOTER //
// ./registration/creative/containers/substep2_4.jsx